export const routePath = {
    root: "/",
    consentResponse: "/consent-response",
    controlAppRedirect: "/ca-redirect",
    wizard: "/wizard",
};
